import { httpClient } from './http-client'

export { httpServerClient } from './http-server-client'
export { baseFetcher } from './base-fetcher'
export { httpClient }

// for backward compatibility
export default httpClient
